module.exports = __webpack_public_path__ + "img/message-course@3x.c477464b.png";